import React from "react";
import sfc from "../../assets/images/review/efc.png";
import apr from "../../assets/images/review/apr.png";
import prm from "../../assets/images/review/prm.png";

const FeaturesList = () => {
  return (
    <section className="tw-py-20 lg:tw-py-28 tw-bg-slate-50/40 tw-border-t tw-border-solid tw-border-slate-100">
      <div className="tw-max-w-7xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8 tw-space-y-24 lg:tw-space-y-36">

        {/* Section 1: Streamline Feedback Collection */}
        <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-12 tw-gap-12 tw-items-center">
          {/* Left: Text */}
          <div className="lg:tw-col-span-7 tw-text-left">
            <h2 className="tw-text-2xl sm:tw-text-3xl tw-font-extrabold tw-text-slate-900 tw-leading-tight tw-mb-6">
              Streamline Feedback Collection
            </h2>
            <p className="tw-text-base tw-text-slate-600 tw-leading-relaxed tw-m-0">
              Capture guest insights effortlessly with automated surveys and QR code scans. BeyondLeadz sends timely review reminders, ensuring every guest’s voice is heard and helping you build trust and loyalty. Simplifying the review process encourages more guests to share valuable feedback.
            </p>
          </div>
          {/* Right: Image */}
          <div className="lg:tw-col-span-5 tw-flex tw-justify-center">
            <div className="tw-relative">
              <div className="hero-img-glow tw-opacity-30 tw-blur-2xl" />
              <img
                src={sfc}
                alt="Streamline Feedback Collection"
                className="tw-max-w-full tw-h-auto tw-rounded-3xl img-shadow-indigo"
                loading="lazy"
              />
            </div>
          </div>
        </div>

        {/* Section 2: AI-Driven Personalized Responses */}
        <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-12 tw-gap-12 tw-items-center">
          {/* Left: Image (Order-last on mobile, first on desktop) */}
          <div className="lg:tw-col-span-5 tw-flex tw-justify-center tw-order-last lg:tw-order-first">
            <div className="tw-relative">
              <div className="hero-img-glow tw-opacity-30 tw-blur-2xl" />
              <img
                src={apr}
                alt="AI-Driven Personalized Responses"
                className="tw-max-w-full tw-h-auto tw-rounded-3xl img-shadow-indigo"
                loading="lazy"
              />
            </div>
          </div>
          {/* Right: Text */}
          <div className="lg:tw-col-span-7 tw-text-left">
            <h2 className="tw-text-2xl sm:tw-text-3xl tw-font-extrabold tw-text-slate-900 tw-leading-tight tw-mb-6">
              AI-Driven Personalized Responses
            </h2>
            <p className="tw-text-base tw-text-slate-600 tw-leading-relaxed tw-m-0">
              Use AI to create tailored replies to guest reviews, saving time and maintaining engagement. BeyondLeadz’s AI generates thoughtful responses, ensuring guest satisfaction and highlighting your dedication to service. With routine responses automated, your team can focus on delivering exceptional guest experiences.
            </p>
          </div>
        </div>

        {/* Section 3: Proactive Reputation Management */}
        <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-12 tw-gap-12 tw-items-center">
          {/* Left: Text */}
          <div className="lg:tw-col-span-7 tw-text-left">
            <h2 className="tw-text-2xl sm:tw-text-3xl tw-font-extrabold tw-text-slate-900 tw-leading-tight tw-mb-6">
              Proactive Reputation Management
            </h2>
            <p className="tw-text-base tw-text-slate-600 tw-leading-relaxed tw-m-0">
              Address guest concerns promptly to prevent negative reviews. BeyondLeadz alerts your team to potential issues, allowing swift intervention. This approach helps maintain a positive reputation and demonstrates your commitment to guest satisfaction.
            </p>
          </div>
          {/* Right: Image */}
          <div className="lg:tw-col-span-5 tw-flex tw-justify-center">
            <div className="tw-relative">
              <div className="hero-img-glow tw-opacity-30 tw-blur-2xl" />
              <img
                src={prm}
                alt="Proactive Reputation Management"
                className="tw-max-w-full tw-h-auto tw-rounded-3xl img-shadow-indigo"
                loading="lazy"
              />
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default FeaturesList;
